import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input, OnInit, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { EcmMaterialModule, EcmMaterialPipeModule } from '@ecm/material';
import { EcmRouterModule, Link, LinkService, RouterService, TrackingData } from '@ecm/router';

import { TmsCodes } from '../../../business/model/tracking/tmsCodes.enum';
import { BreakpointService } from '../../../services/breakpoint.service';
import { UrlService } from '../../../services/url.service';
import { ParamsUtils } from '../../../utils/params.utils';
import { MegapushUtils } from './megapush.utils';

@Component({
    selector: 'megapush',
    templateUrl: 'megapush.html',
    styleUrls: ['megapush.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgTemplateOutlet, EcmMaterialModule, EcmRouterModule, EcmMaterialPipeModule],
})
export class MegapushComponent implements OnInit {
    private _breakpointService: BreakpointService = inject(BreakpointService);
    private _linkService: LinkService = inject(LinkService);
    private _routerService: RouterService = inject(RouterService);
    private _urlService: UrlService = inject(UrlService);

    // max-width < 735px
    public isMobileWidth = toSignal(this._breakpointService.isMobileWidth());
    public isSosh = toSignal(this._routerService.isCurrentRouteSosh());

    public cid = input<string>();
    public img159 = input.required<string>();
    public img160 = input.required<string>();
    public text = input.required({
        transform: (value: string) => MegapushUtils.transformContent(value, this.isMobileWidth()),
    });
    public text2 = input<string>();
    public title = input.required({
        transform: (value: string) => MegapushUtils.transformContent(value, this.isMobileWidth()),
    });
    public trackingData = input<TrackingData>();
    public urlLabel = input.required<string>();
    public urlWeb = input.required<Link>();

    public hrefWeb = computed(() => this._linkService.getLinkSync(this.urlWeb(), ParamsUtils.cidMap(this.cid())));
    public trackingDatas = computed(() => {
        if (!this.trackingData()) {
            return undefined;
        }
        if (this.cid()) {
            this.trackingData().cappingTracking.cid = this.cid();
        }
        return this.trackingData();
    });

    public zid?: string;
    public isDisabledEclairLink?: boolean;

    protected readonly ParamsUtils = ParamsUtils;

    public ngOnInit(): void {
        if (this.isSosh()) {
            this.zid = this.isMobileWidth()
                ? TmsCodes.care_digital_megapush_sosh_zidMob
                : TmsCodes.care_digital_megapush_sosh_zid;
        } else {
            this.zid = this.isMobileWidth()
                ? TmsCodes.care_digital_megapush_zidMob
                : TmsCodes.care_digital_megapush_zid;
        }
        if (this.urlWeb()) {
            this.isDisabledEclairLink = this._urlService.isDisabledEclairLink(this.urlWeb());
        }
    }

    public openLink(): void {
        this._linkService.openLink(this.urlWeb(), this.trackingDatas(), ParamsUtils.cidMap(this.cid()));
    }
}
